module.exports = __webpack_public_path__ + "j.no1.bc5206bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/j.no1.jpg
// module id = 8YS3
// module chunks = 0